import React from 'react';
import { Box, Container } from '@mui/material';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import AppRoutes from '../AppRoute/Route';

const DefaultLayout = ({ children }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      minHeight="100vh"
      sx={{
        backgroundColor: '#f0f0f0',
        overflowX: 'hidden', // avoid horizontal scroll on small devices
      }}
    >
      <Header />

      <Container
        component="main"
        disableGutters
        maxWidth={false}
        sx={{
          flex: 1,
          px:0,
          py: 0,        
          width: '100%',
          backgroundColor: '#ffffff',
        }}
      >
        <AppRoutes />
      </Container>

      <Footer />
    </Box>
  );
};

export default DefaultLayout;
